import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-weavy-large.tsx
/**
* icon.24.logo.weavy.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNOCAxNGgyVjVoNHY5aDJWNWg0djloLTN2NWgtNHYtNWgtMnY1SDd2LTVINFY1aDR6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=18068-8288
*/
const Icon24LogoWeavyLarge = memo(function Icon24LogoWeavyLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M8 14h2V5h4v9h2V5h4v9h-3v5h-4v-5h-2v5H7v-5H4V5h4z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24LogoWeavyLarge };

//# sourceMappingURL=icon-24-logo-weavy-large.js.map